export function isUndefined<TValue>(value: TValue | undefined): value is undefined {
	return value === undefined;
}
